import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import SendIcon from "@mui/icons-material/Send";
import Link from "next/link";
import { useTranslation } from "next-i18next";

/**
 * Request Sent step / screen.
 *
 * Usually shown after completing the request access flow.
 */
export function RequestSent() {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Avatar
            sx={(theme) => ({
              width: "7rem",
              height: "7rem",
              backgroundColor: theme.palette.gray["10"],
            })}
          >
            <SendIcon
              sx={(theme) => ({
                height: "4rem",
                width: "4rem",
                color: theme.palette.lightBlue["50"],
              })}
            />
          </Avatar>
        </Box>

        <Box>
          <Typography variant="h3">
            {t("request_access:request_sent.request_sent")}
          </Typography>
        </Box>

        <Box>
          <Typography>
            {t("request_access:request_sent.request_sent_check_email")}
          </Typography>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Button LinkComponent={Link} href="/?a=request-access-finished">
            {t("request_access:request_sent.go_to_mycargill")}
          </Button>
        </Box>
      </Box>
    </>
  );
}
